import { Component, OnInit } from '@angular/core';
import { environment } from '@env/environment';
import { HttpUtilService } from '@services/http-util.service';
import { NotificationsService } from '@services/notifications.service';
import { UserService } from '@services/user.service';

@Component({
  selector: 'app-snowflake-access',
  templateUrl: './snowflake-access.component.html',
  styleUrls: ['./snowflake-access.component.scss']
})
export class SnowflakeAccessComponent implements OnInit {

  constructor(private http: HttpUtilService, private userService: UserService, private notificationService: NotificationsService) { }
  user:any;
  snowflakeAccount: string;
  snowflakeDatabase: string;
  snowflakeSchema: string;
  snowflakeWarehouse: string;
  snowflakeRole: string;
  snowflakeUser: string;
  ngOnInit() {
    this.userService.getRoleDetails().subscribe((res: any) => {
      this.user = res;
      this.getDetails();
    });
  }

  getDetails(){
    this.http.request('GET', environment.apiRoot + '/snowflake/access', {}, null, true).subscribe((res: any) => {
      this.snowflakeAccount = res.snowflakeAccount;
      this.snowflakeDatabase = res.snowflakeDatabase;
      this.snowflakeSchema = res.snowflakeSchema;
      this.snowflakeWarehouse = res.snowflakeWarehouse;
      this.snowflakeRole = res.snowflakeRole;
      this.snowflakeUser = res.snowflakeUser;
    });
  }

  activateSnowflakeUser(){
    this.http.request('POST',environment.apiRoot + '/snowflake/access', {}, null, true, false, true).subscribe((res: any) => {
      if(res.status == 'success'){
        this.notificationService.popNotification('Snowflake account created','',10);
        this.snowflakeUser = this.user.cognito_username;
      } else {
        this.notificationService.popNotification('Error creating Snowflake account: ' + res.errorMessage,'',10);
      }
    });
  }

  resetSnowflakeUser(){
    this.http.request('PUT',environment.apiRoot + '/snowflake/access', {}, null, true, false, true).subscribe((res: any) => {
      if(res.status == 'success'){
        this.notificationService.popNotification(res.message,'',10);
      } else {
        this.notificationService.popNotification('Error resetting Snowflake account: ' + res.errorMessage,'',10);
      }
    });
  }

}
